import state from './acmpolicy.state'
import mutations from './acmpolicy.mutations'
import actions from './acmpolicy.actions'

export default {
  state,
  mutations,
  actions
}
